function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import "./checkbox.css";
import { UnstyledUncontrolledCheckbox } from "../../unstyled/checkbox/UnstyledUncontrolledCheckbox";

/*
    Returns an uncontrolled checkbox

    props
        (object)    checkboxIndicator   An object of the icons to use for the checkbox
                                            - Example = {
                                                checked: <img src={checkSquareIcon}>,
                                                unchecked: <img src={emptySquareIcon}>
                                            }
        (boolean)   defaultChecked      (part of the ...rest props) When true, the checkbox is checked by default. 
                                            - Do not use defaultChecked with the controlled component                                            
        (boolean)   error               When true, an error classname is added to allow special error styling (like red text)
        (jsx)       helperText          A message to show below the checkbox
        (children)  children            The content/label of the checkbox        
*/

const UncontrolledCheckbox = ({
  classPrepend = "styled",
  className = "",
  checkboxIndicator = {
    checked: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    })),
    unchecked: null
  },
  disabled = false,
  error = false,
  helperText = "",
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledUncontrolledCheckbox, _extends({
    classPrepend: classPrepend,
    className: `${className} ${disabled ? "checkbox-disabled" : ""}`,
    checkboxIndicator: checkboxIndicator,
    disabled: disabled,
    error: error,
    helperText: helperText
  }, rest), children);
};
export { UncontrolledCheckbox };